Object.defineProperty(exports, "__esModule", { value: true });
exports.makeStyles = void 0;
var makeStyles_1 = require("./makeStyles");
Object.defineProperty(exports, "makeStyles", { enumerable: true, get: function () { return makeStyles_1.makeStyles; } });
exports.default = makeStyles_1.makeStyles;
//# sourceMappingURL=index.js.map